import {packId} from 'common/diplomatIdUtil';
import * as Yup from 'common/yup';
import {DiplomatObjectType} from './DiplomatObjectType';

export const Timestamped = Yup.object({
   /** Timestamp in milliseconds.*/
   timestamp: Yup.number(),
   /** User ID of the last user to make a change.*/
   lastUser: Yup.string(),
});

export const DiplomatObjectNames = {
   id: 'id',
   objectType: 'objectType',
   name: 'name',
   folderId: 'folderId',
   suspended: 'suspended',

   _packedId: '_packedId',
   _id: '_id', // original id if id was modified for tree nav
} as const;

export const diplomatObjectSchema = Timestamped.shape({
   [DiplomatObjectNames.id]: Yup.idString(),
   [DiplomatObjectNames._id]: Yup.originString(),
   [DiplomatObjectNames._packedId]: Yup.originString(),
   [DiplomatObjectNames.objectType]: Yup.string().oneOf(DiplomatObjectType.keys),
   [DiplomatObjectNames.name]: Yup.string(),
   [DiplomatObjectNames.folderId]: Yup.string(),
   [DiplomatObjectNames.suspended]: Yup.boolean(),
}).transform(function (val, origin) {
   if (val && !val._packedId) {
      val._packedId = packId(origin.objectType, origin.id);
   }

   if (val && !val._id) {
      val._id = origin.id;
   }

   return val;
});
